import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { Service } from '@/types/meetings.type';

/**
 * Get all services
 */
export const getAllServices = async (): Promise<Array<Service>> => {
  return apiClient.get<Array<Service>>(API_ROUTES.SERVICES);
};

/**
 * Get public services (show_public = true)
 */
export const getPublicServices = async (): Promise<Array<Service>> => {
  return apiClient.get<Array<Service>>(`${API_ROUTES.SERVICES}?public=true`);
};

/**
 * Get a single service by ID
 */
export const getServiceById = async (id: string): Promise<Service> => {
  return apiClient.get<Service>(API_ROUTES.SERVICE_BY_ID(id));
};
